<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="2"></v-col>
      <v-col cols="12" md="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span class="font-weight-bold">เลือกเพจที่ต้องการ</span>
          </div>
          <div class="mx-5">
            <v-row v-for="(item, index) in pageList" :key="index">
              <v-col cols="12" md="2">
                <v-img :aspect-ratio="1 / 1" :src="item.picture"></v-img>
              </v-col>
              <v-col cols="12" md="7" :align-self="`center`">
                <strong>{{ item.name }}</strong>
                <div class="grey--text">ID : {{ item.id }}</div>
              </v-col>
              <v-col cols="12" md="3" :align-self="`center`" class="text-right">
                <v-btn
                  v-if="!item.connected"
                  small
                  depressed
                  color="primary"
                  dark
                  :block="$vuetify.breakpoint.xs ? true : false"
                  @click="connectFBPage(item)"
                  >เชื่อมต่อ</v-btn
                >
                <v-btn
                  v-else
                  :to="`/live-commerce/` + item.id"
                  small
                  depressed
                  :block="$vuetify.breakpoint.xs ? true : false"
                  color="primary"
                  >เริ่มต้นใช้งาน</v-btn
                >
              </v-col>
            </v-row>
          </div>
          <div class="divider-dashed"></div>
          <div class="mt-5 text-center" v-if="mode == 'connected'">
            หรือกดปุ่มด้านล่าง หากต้องการเชื่อมต่อกับเพจอื่นๆของคุณ
            <div class="mt-3">
              <v-btn depressed color="blue darken-2" dark @click="loginFB()"
                >เชื่อมต่อเพจใหม่
              </v-btn>
            </div>
          </div>
        </el-card>
      </v-col>
      <v-col cols="12" md="2"></v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";
export default {
  computed: {
    ...mapState({
      storeVideo: (state) => {
        return state.LiveCommerce.video;
      },
    }),
  },
  data() {
    return {
      fbAccessToken: null,
      userID: null,
      messageList: [],
      video: {
        id: null,
      },
      isStart: false,
      hashtag: "",
      watched: "",
      videoList: [],
      pageList: [],
      mode: "connected",
    };
  },
  created() {
    Service.LiveCommerce.getConnectedPages({ ent_id: 2 }).then((res) => {
      this.pageList = res.data.pages.map((item) => {
        return {
          name: item.page_name,
          id: item.page_id,
          picture: item.page_logo,
          connected: true,
        };
      });

      if (this.pageList.length < 1) {
        window.FB.getLoginStatus((response) => {
          //console.log(response);
          if (response.status === "connected") {
            this.fbAccessToken = response.authResponse.accessToken;
            this.userID = response.authResponse.userID;
            this.getPagesInfo();
          } else {
            this.loginFB();
          }
        });
      }
    });

    /*
    Service.LiveCommerce.validate({ ent_id: 2 }).then((res) => {
      console.log(res);
    });
    */
    //this.startReadComment();
  },
  methods: {
    loginFB() {
      window.FB.login(
        (response) => {
          if (response.authResponse) {
            this.fbAccessToken = response.authResponse.accessToken;

            this.getPagesInfo();
          } else {
            console.log("User cancelled login or did not fully authorize.");
          }
        },
        {
          scope:
            "public_profile,email,pages_show_list,pages_manage_metadata,pages_messaging,pages_read_engagement,pages_read_user_content",
        }
      );
    },
    getPagesInfo() {
      window.FB.api("/me", (me) => {
        let user_id = me.id;
        this.userID = me.id;
        window.FB.api(
          "/" + user_id + "/accounts?fields=id,name,picture,page_token",
          (accounts) => {
            if (accounts && !accounts.error) {
              this.pageList = accounts.data.map((item) => {
                return {
                  name: item.name,
                  id: item.id,
                  picture: item.picture.data.url,
                };
              });
              this.mode = "facebook";
            }
          }
        );
      });
    },
    connectFBPage(item) {
      let data = {
        ent_id: 2,
        page_id: item.id,
        fb_access_token: this.fbAccessToken,
        user_id: this.userID,
      };

      Service.LiveCommerce.onboarding(data).then((res) => {
        if (res.success) {
          this.$router.go(this.$router.currentRoute);
        }
      });
    },
    saveLiveVideo() {
      this.$store.dispatch("LiveCommerce/setVideo", this.video);
      this.startReadComment();
    },
    saveHasTag() {
      //this.$store.dispatch("LiveCommerce/setHashtag", this.hashtag);
      this.watched = this.hashtag;
    },
    getLiveVideos() {
      var self = this;
      window.FB.api("/101018818320458/live_videos", (response) => {
        if (response && !response.error) {
          self.videoList = response.data;
        }
      });
    },
    startReadComment() {
      var self = this;
      self.video.id = self.storeVideo.id;
      setTimeout(() => {
        var source = new EventSource(
          "https://streaming-graph.facebook.com/180631437025862/live_comments?access_token=EAAIKknODisEBAFKJeBzMEynkMrxfGbgUOJg3TB0Ptaz99ZCG04rhz7YX2xZBX0Rx0RAL8ETnTDoy8guhIcLRmA9lYuNUSad403uerhWHX6mLZBgqow5rTNe9h2KrXqHdHZAGndtTEeWXpiTj6JmsrsWhNQaUb8xOCnoL9TTBg2iZCjverHJIAvIZC3vZCAoQmkZD&comment_rate=ten_per_second&fields=from{id,name},id,message"
        );
        source.onmessage = function (event) {
          //Do something with event.message for example
          let data = JSON.parse(event.data);
          console.log(data);

          var a = new RegExp("\\b" + self.watched + "\\b");

          self.messageList.unshift({
            message: data.message,
            matched: a.test(data.message),
          });
        };
        this.isStart = true;
      }, 1000);
    },
    clearComments() {
      this.messageList = [];
    },
  },
};
</script>
